@use 'style/utils';

$_CLASS: '.joy-select';

:host::slotted(joy-option) {
    display: none !important;
}

#{$_CLASS}__wrapper {
    * {
        box-sizing: border-box;
        outline: none;
    }

    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    --select-transition: var(--joy-transition-duration-short);

    --select-color: var(--joy-color-neutral-50);
    --select-color-background: white;
    --select-icon-color: var(--joy-color-neutral-40);
    --select-border-color: var(--joy-color-neutral-30);
    --select-border-radius: var(--joy-form-field-radius-medium);
    --select-font-size: var(--joy-font-size-primary-400);

    --select-select-border: var(--joy-form-border-width) solid var(--joy-color-secondary-50);
    --select-select-border-radius: var(--select-border-radius);
    --select-select-max-height: 200px;
    --select-select-max-height-mobile: 50vh;
    --select-select-zindex: var(--joy-core-z-index-select);
}


#{$_CLASS} {
    position: relative;
    display: block;
    width: 100%;
    font-family: var(--joy-font-family);
    margin-bottom: 0;
    cursor: pointer;
    appearance: none;
    height: var(--select-height);
    border: var(--joy-form-border-width) solid var(--select-border-color);
    border-radius: var(--select-border-radius);
    color: var(--select-color);
    font-size: var(--select-font-size);
    background: var(--select-color-background);
    padding: 0 var(--joy-core-spacing-10) 0 var(--joy-core-spacing-5);
    transition: all var(--select-transition) var(--joy-transition-timing-function);
}

#{$_CLASS}:focus {
    --select-color: var(--joy-color-secondary-30);
    --select-border-color: var(--joy-color-secondary-30);
    --select-icon-color: var(--joy-color-secondary-30);

    ::slotted(option) {
        color: var(--joy-color-neutral-60);
        font-size: var(--joy-font-size-primary-300);
        font-family: var(--joy-font-family);
        background-color: white;

        &:disabled {
            background-color: var(--joy-color-neutral-10);
            color: var(--joy-color-neutral-40);
        }
    }
}

#{$_CLASS}:not([disabled]):hover {
    --select-border-color: var(--joy-color-secondary-30);
}

#{$_CLASS}--disabled {
    --select-color: var(--joy-color-neutral-40);
    --select-border-color: var(--joy-color-neutral-30);
    --select-color-background: var(--joy-color-neutral-10);
    --select-icon-color: var(--joy-color-neutral-30);

    select {
        cursor: not-allowed;
    }
}

#{$_CLASS}--invalid {
    --select-icon-color: var(--joy-color-error-50);

    &:hover {
        --select-icon-color: var(--joy-color-state-error-hover);
    }

    select {
        --select-color: var(--joy-color-error-50);
        --select-border-color: var(--joy-color-error-50);

        &:hover {
            --select-color: var(--joy-color-state-hover-error);
            --select-border-color: var(--joy-color-state-hover-error);
        }
    }
}

#{$_CLASS}__chevron {
    pointer-events: none; // in order to click on all select area
    position: absolute;
    right: var(--joy-core-spacing-5);
    color: var(--select-icon-color);
    transition: transform var(--select-transition) var(--joy-transition-timing-function);
}

#{$_CLASS}__slotted-options-wrapper {
    display: none !important;
}

#{$_CLASS}__wrapper {
    @each $size, $config in utils.$FORM_SIZES {
        &#{$_CLASS}--#{$size} {
            --select-height: #{map-get($config, height)};
            --select-font-size: #{map-get($config, fontSize)};

            $iconSize: map-get($config, iconSize);

            @if $iconSize {
                #{$_CLASS}__chevron {
                    --icon-size: #{$iconSize};
                }
            }
        }
    }
}